import domReady from '@wordpress/dom-ready';

function extraireID(url) {
  const regex =
    /(?:youtu\.be\/|youtube\.com\/(?:v|e(?:mbed)?)\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

domReady(() => {
  const embeds = document.querySelectorAll('.video-thumbnail-embed');

  if (0 < embeds.length) {
    embeds.forEach((embed) => {
      const button = embed.querySelector('.video-thumbnail-embed__button');
      let iframeYoutubeTemp = embed.querySelector(
        '.video-thumbnail-embed__video iframe'
      );
      let videoSrc = '';
      if (iframeYoutubeTemp) {
        videoSrc = iframeYoutubeTemp.getAttribute('src');
      } else {
        iframeYoutubeTemp = embed.querySelector('.rll-youtube-player');
        videoSrc = iframeYoutubeTemp.dataset.src;
      }
      const videoID = extraireID(videoSrc);

      iframeYoutubeTemp.remove();

      button.addEventListener('click', (event) => {
        event.preventDefault();
        embed.classList.add('video-thumbnail-embed--playing');

        const iframe = document.createElement('iframe');
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.src = `https://www.youtube.com/embed/${videoID}?autoplay=1`;
        iframe.title = 'YouTube video player';
        iframe.frameBorder = '0';
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;

        embed
          .querySelector('.video-thumbnail-embed__video')
          .appendChild(iframe);
      });
    });
  }
});
